import {createContext} from "react";

export const AdvertiserAndDateFilterContext = createContext(null);
